import { Box, Text } from "@chakra-ui/react";

export default function MessageItem({ messageItem, selectedChatBg, chatBg }) {
  const getMessageObj = () => {
    let message = ""
    try {
      message = JSON.parse(messageItem?.message);
    } catch (error) {
      console.error(error);
      message = messageItem;
    }

    return message
  };

  const messageData = getMessageObj()

  return (
    <Box
      borderRadius={"md"}
      maxW={720}
      whiteSpace={"wrap"}
      p={2}
      color={
        messageItem.sentBy === "agent" || messageItem.sentBy === "assistant"
          ? "black"
          : "white"
      }
      bg={
        messageItem.sentBy === "agent" || messageItem.sentBy === "assistant"
          ? "gray.100"
          : selectedChatBg
      }
    >
      <Text>{messageData.message}</Text>
    </Box>
  );
}
